import React, { useEffect } from 'react';
import { Flex } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { AttributesAction } from '../components/AttributesAction';
import {
    AttributesFilters,
    AttributesTableProps,
} from '../service/attributes.interface';
import { useLazyReadAttributesQuery } from '../service/attributes';
import { useFilters } from '../../products/hooks/useFilters';
import { AiDisputeNotification } from '../components/AIDisputeNotification';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import {
    selectAttributesState,
    setAIRecommends,
} from '../store/attributesSlice';
import { AttributesTable } from '../components/AttributesTable';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const AttributesContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const {
        updateFilters,
        filters,
        get: fetchAttributes,
        source,
        loading,
        isSuccess,
    } = useFilters<AttributesFilters, AttributesTableProps>(
        useLazyReadAttributesQuery,
        null
    );

    const dispatch = useDispatch();
    const { is_ai_recommends } = useSelector(selectAttributesState);

    const isBlocked = is_ai_recommends;

    useEffect(() => {
        const timeout = setTimeout(() => {
            const payload = {
                id: +current.id,
                ...filters,
            };

            fetchAttributes(payload, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, fetchAttributes, current]);

    useEffect(() => {
        if (isSuccess) {
            dispatch(setAIRecommends(false));
        }
    }, [isSuccess, dispatch]);

    useEffect(() => {
        dispatch(setAIRecommends(source.is_ai_recommends));
    }, [source.is_ai_recommends, dispatch]);

    return (
        <Flex vertical gap={24}>
            <AttributesAction isBlocked={isBlocked} loading={loading} />

            <AiDisputeNotification
                source={source}
                fetchAttributes={fetchAttributes}
                filters={filters}
                loading={loading}
            />

            <AttributesTable
                isBlocked={isBlocked}
                updateFilters={updateFilters}
                filters={filters}
                source={source}
                loading={loading}
            />
        </Flex>
    );
};
